import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes.js'
import store from '@/store'
// import includes from 'lodash/includes'
// import { Store } from 'vuex'
Vue.use(Router)
const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes
})
//

// 前置导航守卫 路由拦截器 所有路由跳转前经过其处理
router.beforeEach((to, from, next) => {
  document.title = 'Bonree License'
  let user = store.state.user
  //
  const loginUrl = '/login'
  if(to.path==='/active' || to.path=== '/trial') {
    next()
    return
  }

  if (to.path !== loginUrl) {
    if(user.isLogin){
      //已登录
      next()
    }else{
      //未登录
      store.dispatch('user/getLogin').then(res=>{
        if(user.isLogin){
          next()
        }else{
          next(loginUrl)
        }
      })
    }
  }else{
    next()
  }
})

export default router
